export enum SupportedLanguages {
    'fr' = 'fr',
    'en' = 'en',
    'it' = 'it',
    'sodexo' = 'sodexo',
    'es' = 'es',
    'zh-CN' = 'zh-CN',
    'zh-TW' = 'zh-TW',
    'ar' = 'ar',
    'de' = 'de',
}

export const SupportedApiLanguages = {
    [SupportedLanguages.fr]: 'fr',
    [SupportedLanguages.en]: 'en',
    [SupportedLanguages.it]: 'it',
    [SupportedLanguages.sodexo]: 'fr',
    [SupportedLanguages.es]: 'es',
    [SupportedLanguages['zh-CN']]: 'zh-CN',
    [SupportedLanguages['zh-TW']]: 'zh-TW',
    [SupportedLanguages.ar]: 'ar',
    [SupportedLanguages.de]: 'de',
};

export function getLocale(): SupportedLanguages {
    const locale: string = (navigator.languages && navigator.languages[0]) || navigator.language;

    switch (locale) {
        case 'fr-FR':
        case 'fr':
            return SupportedLanguages.fr;
        case 'en-GB':
        case 'en-US':
        case 'en':
            return SupportedLanguages.en;
        case 'it-IT':
        case 'it':
            return SupportedLanguages.it;
        case 'sodexo-SODEXO':
        case 'sodexo':
            return SupportedLanguages.sodexo;
        case 'es-ES':
        case 'es-MX':
        case 'es-AR':
        case 'es':
            return SupportedLanguages.es;
        case 'zh-CN':
        case 'zh-Hans':
        case 'zh-Hans-CN':
        case 'zh-SG':
        case 'zh':
            return SupportedLanguages['zh-CN'];
        case 'zh-TW':
        case 'zh-Hant':
        case 'zh-Hant-TW':
        case 'zh-HK':
        case 'zh-MO':
            return SupportedLanguages['zh-TW'];
        case 'ar-SA':
        case 'ar-EG':
        case 'ar-AE':
        case 'ar-MA':
        case 'ar':
            return SupportedLanguages.ar;
        case 'de-DE':
        case 'de-AT':
        case 'de-CH':
        case 'de':
            return SupportedLanguages.de;

        default:
            return SupportedLanguages.fr;
    }
}

export const localeStringMap = {
    [SupportedLanguages.fr]: 'fr-FR',
    [SupportedLanguages.en]: 'en-GB',
    [SupportedLanguages.it]: 'it-IT',
    [SupportedLanguages.sodexo]: 'sodexo-SODEXO',
    [SupportedLanguages.es]: 'es-ES',
    [SupportedLanguages['zh-CN']]: 'zh-CN',
    [SupportedLanguages['zh-TW']]: 'zh-TW',
    [SupportedLanguages.ar]: 'ar-SA',
    [SupportedLanguages.de]: 'de-DE',
};
